// Norwegian field titles that already begin with an imperative ("Velg
// produsent", "Velg lokalitet") read malformed as "Du må fylle ut velg
// produsent". Map the imperative to its infinitive so the "Velg …" family
// becomes "Du må velge produsent"; unknown verbs keep the generic
// "Du må fylle ut …" template.
const IMPERATIVE_TO_INFINITIVE: Record<string, string> = {
  velg: 'velge'
}

const splitFirstWord = (lowercased: string): [string, string] => {
  const [firstWord = '', ...rest] = lowercased.split(/\s+/)
  return [firstWord, rest.join(' ').trim()]
}

/** Lowercased label ready for the "Du må …"/"Du må fylle ut …" templates,
 *  with an imperative prompt verb mapped to its infinitive
 *  ("Velg produsent" -> "velge produsent"). */
export const requiredFieldPhrase = (label: string): string => {
  const lowercasedLabel = label.toLowerCase()
  const [firstWord, remainder] = splitFirstWord(lowercasedLabel)
  const infinitive = IMPERATIVE_TO_INFINITIVE[firstWord]
  return infinitive
    ? [infinitive, remainder].filter(Boolean).join(' ')
    : lowercasedLabel
}

/** Full user-facing "required field" message for a field title, e.g.
 *  "Tilsynsobjekt-ID" -> "Du må fylle ut tilsynsobjekt-id" and the
 *  imperative "Velg produsent" -> "Du må velge produsent". */
export const requiredFieldMessage = (label: string): string => {
  const lowercasedLabel = label.toLowerCase()
  const [firstWord] = splitFirstWord(lowercasedLabel)
  const phrase = requiredFieldPhrase(label)
  return IMPERATIVE_TO_INFINITIVE[firstWord]
    ? `Du må ${phrase}`
    : `Du må fylle ut ${phrase}`
}
